<template>
  <div>
    <img :src="imgURL">
  </div>
</template>

<script>
export default {
  props: {
    imgURL : {
      type: String,
      default: ""
    }
  }
}
</script>

<style scoped lang="scss">
img{
  width: 100%;
}
</style>